export const RESOURCES = 'https://services.xbot.com.vn:1251';
